import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { VersionUpdateService } from './version-update-service';

/**
 * This HTTP interceptor adds a header to HTTP requests indicating the client version.
 */
@Injectable()
export class VersioningInterceptor implements HttpInterceptor {

	/** The name of the HTTP header for the client version. */
	private static readonly CLIENT_VERSION_HEADER_NAME: string = "crown-x-client-version";

	/**
	 * @constructor
	 *
	 * @param versionUpdateService The service used for checking and initiating client updates when an update is available
	 */
	constructor(
		private readonly versionUpdateService: VersionUpdateService
	) { }

	/**
	 * Adds a header to the outgoing http request indicating the client version.
	 * 
	 * @param request The outgoing request object to handle.
	 * @param next The next interceptor in the chain, or the back-end if no interceptors remain in the chain.
	 */
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let outgoingRequest: HttpRequest<any> = request;
		outgoingRequest = request.clone({ headers: request.headers.append(VersioningInterceptor.CLIENT_VERSION_HEADER_NAME , environment.Version) });

		return next.handle(outgoingRequest).pipe(catchError((error: any) => {
			if (error.status == HttpStatusCode.UpgradeRequired) {
				/**
				 * This sets the IsServerRejectingRequests on the versionUpdateService to true to indicate that the api calls are being rejected due to a required update.
				 * We don't need to worry about setting the flag to false on okay results, due to some api being allowed through on version update required
				 * and the fact that it automatically gets set to false on refresh which is necessary as part of the upgrade.
				 */
				this.versionUpdateService.IsServerRejectingRequests = true;
			}
			return throwError(() => error);
		}));
	}
}
